import {
	CognitoUserPool,
	CognitoUser,
	AuthenticationDetails,
} from 'amazon-cognito-identity-js';

const poolData = {
	UserPoolId: 'us-east-1_3uQjdJPbs',
	ClientId: '65jqejqov6dl625javk6uvt4gj',
};

const userPool = new CognitoUserPool(poolData);

export const signIn = (email, password) =>
	new Promise((resolve, reject) => {
		const user = new CognitoUser({ Username: email, Pool: userPool });
		const auth = new AuthenticationDetails({
			Username: email,
			Password: password,
		});
		user.authenticateUser(auth, {
			onSuccess: (session) => resolve({ user, session }),
			onFailure: (err) => reject(err),
			newPasswordRequired: (userAttributes) => {
				resolve({ user, newPasswordRequired: true, userAttributes });
			},
		});
	});

export const completeNewPassword = (user, newPassword) =>
	new Promise((resolve, reject) => {
		user.completeNewPasswordChallenge(
			newPassword,
			{},
			{
				onSuccess: (session) => resolve(session),
				onFailure: (err) => reject(err),
			},
		);
	});

export const signOut = () => {
	const user = userPool.getCurrentUser();
	if (user) user.signOut();
};

export const getSession = () =>
	new Promise((resolve, reject) => {
		const user = userPool.getCurrentUser();
		if (!user) return resolve(null);
		user.getSession((err, session) => {
			if (err || !session.isValid()) return resolve(null);
			resolve(session);
		});
	});

export const getToken = async () => {
	const session = await getSession();
	return session ? session.getIdToken().getJwtToken() : null;
};

export const getUserGroup = async () => {
	const session = await getSession();
	if (!session) return null;
	const payload = session.getIdToken().decodePayload();
	const groups = payload['cognito:groups'] || [];
	if (groups.includes('Admin')) return 'Admin';
	if (groups.includes('Partner')) return 'Partner';
	if (groups.includes('Descendant')) return 'Descendant';
	return null;
};

export const getCurrentUserEmail = async () => {
	const session = await getSession();
	if (!session) return null;
	return session.getIdToken().decodePayload().email;
};

export const signUp = (email, password, name) =>
	new Promise((resolve, reject) => {
		const attributeList = [
			new (require('amazon-cognito-identity-js').CognitoUserAttribute)({
				Name: 'email',
				Value: email,
			}),
			new (require('amazon-cognito-identity-js').CognitoUserAttribute)({
				Name: 'name',
				Value: name,
			}),
		];
		userPool.signUp(email, password, attributeList, null, (err, result) => {
			if (err) return reject(err);
			resolve(result);
		});
	});

export const confirmSignUp = (email, code) =>
	new Promise((resolve, reject) => {
		const user = new CognitoUser({ Username: email, Pool: userPool });
		user.confirmRegistration(code, true, (err, result) => {
			if (err) return reject(err);
			resolve(result);
		});
	});
